export const useListJoiner = (locale: string, options?: Intl.ListFormatOptions) => new Intl.ListFormat(locale, options);